import { render } from "./index.vue?vue&type=template&id=4955b905&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=4955b905&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/jobs/协会网站/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4955b905"]])

export default __exports__